module.exports = __webpack_public_path__ + "img/Group4.30784414.jpg";